export const getStaticTabByEntityIdMap = (appDefinition) => new Map(appDefinition.staticTabs.map((_, index) => [
    _.entityId.toLowerCase(),
    { tab: _, index },
]));
//# sourceMappingURL=getStaticTabByEntityIdMap.js.map